import { FDStack } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import {
  ClientRiskTolerance,
} from './ClientRiskTolerance';


export const ClientRiskToleranceList = ({ collection }) => {
  return (
    <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2}>
      {collection.resources().list().map((r) => (
        <ClientRiskTolerance key={r.id()} resource={r} />
      ))}
    </FDStack>
  );
};

ClientRiskToleranceList.propTypes = {
  collection: PropTypes.object.isRequired, // A collection of riskToleranceClient
};
